import { useMemo } from 'react';

import { ActivitiesComponentType } from 'global/constants';
import { useLoggingQuery } from 'lib/apollo/apollo-hooks';
import { GET_COMPONENT_TEMPLATES } from 'approot/activity-builder/lesson-builder.graphql';
import type { GetComponentTemplatesQuery } from '../../lesson-builder.graphql.generated';
import { buildComponentMenu } from './component-menu.utils';
import { AddComponentTemplate } from './components-menu.constants';

export const useGetInteractiveTemplates = () => {
  const { data } = useLoggingQuery<GetComponentTemplatesQuery, null>(
    GET_COMPONENT_TEMPLATES
  );

  return {
    data,
  };
};

export const useComponentMenu = ({
  addComponent,
  componentFilter,
}: {
  addComponent: (payload: AddComponentTemplate) => void;
  componentFilter?: ActivitiesComponentType[];
}) => {
  const { data } = useGetInteractiveTemplates();

  const menu = useMemo(() => {
    const templates = data?.getComponentTemplates;
    return templates
      ? buildComponentMenu(templates || [], addComponent, componentFilter)
      : [];
  }, [data, componentFilter, addComponent]);

  return {
    menu,
  };
};
